import React from 'react';

import Coin from '~referral/images/referral_modal/coin.svg';
import Bolt from '~referral/images/icons/bolt.svg';

const Header = ({
  hasUGAccess,
  isUgCgrStreakStats = false,
}) => (
  <div className="psm__form-header">
    <div className="psm__form-img-container">
      <img
        src={Bolt}
        alt="bolt"
        className="psm__form-img"
      />
    </div>
    <div className="psm__form-content-container">
      <div className="nudge-shared-modal__header">
        Share your LinkedIn post’s link
      </div>
      <div className="nudge-shared-modal__attention-strip">
        <span className="nudge-shared-modal__coin-img-container">
          <img
            src={Coin}
            alt="coin"
            className="nudge-shared-modal__coin"
          />
        </span>
        Get
        {' '}
        {
          isUgCgrStreakStats && (150)
        }
        {
          !isUgCgrStreakStats && hasUGAccess
            ? (100)
            : !isUgCgrStreakStats && (200)
        }
        {' '}
        Scaler Coins by sharing the LinkedIn post link!
      </div>
    </div>
  </div>
);

export default Header;
